
export default function AppleLoginBtn({
                                        onSuccess
                                      }) {
  // Không dùng Apple Sign In cho môi trường web
  return null;
}
